import { createAction, props } from '@ngrx/store';
import { Company } from '@models/company.model';

export enum CompanyActions {
  CREATE_COMPANY = '[Companies] Create company',
  CREATE_COMPANY_SUCCESS = '[Companies] Company created',
  CREATE_COMPANY_FAILED = '[Companies] Cannot create company',
  GET_COMPANIES = '[Companies] Get companies',
  GET_COMPANIES_SUCCESS = '[Companies] Companies fetched',
  GET_COMPANIES_FAILED = '[Companies] Cannot fetch companies',
  UPDATE_COMPANY = '[Companies] Update company',
  UPDATE_COMPANY_SUCCESS = '[Companies] Company updated',
  UPDATE_COMPANY_FAILED = '[Companies] Cannot update company',
  DELETE_COMPANY = '[Companies] Delete company',
  DELETE_COMPANY_SUCCESS = '[Companies] Company deleted',
  DELETE_COMPANY_FAILED = '[Companies] Cannot delete company',
  SELECT_COMPANY = '[Companies] Select company',
}

export const fetchCompanies = createAction(CompanyActions.GET_COMPANIES);
export const companiesFetched = createAction(CompanyActions.GET_COMPANIES_SUCCESS, props<{ payload: Company[] }>());
export const cannotFetchCompanies = createAction(CompanyActions.GET_COMPANIES_FAILED, props<{ error: string }>());

export const updateCompany = createAction(CompanyActions.UPDATE_COMPANY, props<{ payload: Company }>());
export const companyUpdated = createAction(CompanyActions.UPDATE_COMPANY_SUCCESS, props<{ payload: Company }>());
export const cannotUpdateCompany = createAction(CompanyActions.UPDATE_COMPANY_FAILED, props<{ error: string }>());

export const createCompany = createAction(CompanyActions.CREATE_COMPANY, props<{ payload: Company }>());
export const companyCreated = createAction(CompanyActions.CREATE_COMPANY_SUCCESS, props<{ payload: Company }>());
export const cannotCreateCompany = createAction(CompanyActions.CREATE_COMPANY_FAILED, props<{ error: string }>());

export const deleteCompany = createAction(CompanyActions.DELETE_COMPANY, props<{ payload: string }>());
export const companyDeleted = createAction(CompanyActions.DELETE_COMPANY_SUCCESS, props<{ payload: string }>());
export const cannotDeleteCompany = createAction(CompanyActions.DELETE_COMPANY_FAILED, props<{ error: string }>());

export const selectCompany = createAction(CompanyActions.SELECT_COMPANY, props<{ payload: string | null }>());
